export interface UnitDisplayOptions {
  units?: any[] | Record<string, any> | null;
  code?: string | null;
  fallbackSymbol?: string | null;
  fallbackName?: string | null;
  fallbackDescription?: string | null;
}

export function getUnitDisplayForUI(opts: UnitDisplayOptions | string): string {
  if (typeof opts === 'string') return opts;
  const { units, code, fallbackSymbol, fallbackName, fallbackDescription } = opts;
  if (code && units) {
    const list = Array.isArray(units) ? units : Object.values(units);
    const found = list.find((u: any) => u?.code === code || u?.codigo === code);
    if (found) {
      return (found.description ?? found.descripcion ?? found.name ?? found.nombre ?? found.symbol ?? found.simbolo ?? code) as string;
    }
  }
  return (fallbackDescription || fallbackName || fallbackSymbol || code || '') as string;
}

export interface UnitDisplayForPrintOptions {
  
  units?: any[] | Record<string, any> | null;
  code?: string | null;
  fallbackSymbol?: string | null;
  fallbackName?: string | null;
  /** 'hoja' shows short symbol; 'ticket' also shows short symbol */
  format?: 'hoja' | 'ticket' | string;
}

/**
 * Resolves a human-readable unit label for printed documents.
 * Looks up `code` in the `units` catalog; falls back to symbol then name.
 */
export function getUnitDisplayForPrint(opts: UnitDisplayForPrintOptions): string {
  const { units, code, fallbackSymbol, fallbackName } = opts;
  if (code && units) {
    const list = Array.isArray(units) ? units : Object.values(units);
    
    const found = list.find((u: any) => u?.code === code || u?.codigo === code);
    if (found) {
      return (found.symbol ?? found.simbolo ?? found.name ?? found.nombre ?? code) as string;
    }
  }
  return (fallbackSymbol || fallbackName || code || '') as string;
}
